export default {"src":"/_next/static/media/icon-clock-solutions.915ad24e.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};